<template>
  <div
    class="cash-content"
    v-if="Object.keys(cashList).length > 0"
    :class="isDisabled ? 'cash-disabled grey' : ''"
  >
    <el-radio
      v-model="selectedMent"
      :label="cashModel ? selectedMent : cashList"
      position="right"
      :disabled="isDisabled"
      :icon="cashList.icon_url"
      :tip="cashList.reason"
      @click.native="handleClick"
      >{{ cashList.payment_name }}</el-radio
    >
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    ...mapState({
      cashList: ({ pay }) => pay.cashList,
      selectedMent: ({ pay }) => pay.selectedMent,
      selectedCard: ({ pay }) => pay.selectedCard,
    }),
    isDisabled() {
      return Number(this.cashList.isDisplay) === 0;
    },
    cashModel() {
      return (
        Number(this.cashList?.channelID) ===
        Number(this.selectedMent?.channelId || this.selectedMent?.channelID)
      );
    },
  },
  mounted() {},
  methods: {
    ...mapMutations('pay', ['setSelectedMent']),
    handleClick() {
      if (!this.isDisabled) {
        this.setSelectedMent(this.cashList);
      }
    },
  },
};
</script>

<style lang="scss">
.cash-content {
  width: 422px;
  background: #fff;
  margin: 20px auto;
  border-radius: 8px;
  padding: 20px 0 20px 20px;
  .el-radio__position {
    width: 382px;
    margin: 0 auto;
  }
  .el-radio__label {
    flex: 1;
    font-size: 16px;
    font-family: 'Aspira Medium';
    font-weight: 500;
  }
  .el-radio__tip {
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 14px;
    line-height: 15px;
    color: #999;
  }
}
.cash-disabled {
  cursor: not-allowed;
  .el-radio {
    cursor: not-allowed;
    color: #666;
  }
}
@media screen and (max-width: 768px) {
  .cash-content {
    width: rem(702);
    margin: rem(20) auto;
    border-radius: rem(12);
    padding: rem(40) 0 rem(40) rem(40);
    .el-radio {
      margin-left: rem(-20);
    }
    .el-radio__position {
      width: rem(650);
    }
    .el-radio__icon {
      width: rem(48);
    }
  }
}
</style>